import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	/**
	 * @param {*} params
	 */
	findAll (params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/events', {
				params: params
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {*} id
	 */
	findOne (id, params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/events/' + id, {params: params}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {*} id
	 */
	getOneById (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/event/seats/' + id, {}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	update (id, data = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/events/' + id, data).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	create (data = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/events', data).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/event/event.js